import CasinoList from "./list";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import {useSelector} from "react-redux";
import SvgIcon from "../../components/svg-icon";
import {useTranslation} from "react-i18next";

const VirtualSports = () => {

    const navigate = useNavigate()
    const {t} = useTranslation()
    const type = 'virtual_sports'


    const {exclusiveGameTypes} = useSelector(state => state.dataReducer)
    const [providersList, setProvidersList] = useState([])

    useEffect(() => {
        setProvidersList([])
        associateServices.getGameProvidersGroup({type}).then(handleProviders)
    }, [type])

    const handleProviders = response => setProvidersList(response?.data || [])


    return (
        <>
            <div className="section section--first">
                <div className="container">
                    {/*<CasinoMainSlider title={t(`sidebar.${type}`)} type={type}/>*/}
                    <div className="col-12">
                        <h1 className="section__title section__title--head">{t(`sidebar.${type}`)}</h1>
                    </div>
                </div>
            </div>
            <div className="section section--last pt-24">
                <div className="container">
                    <CasinoList {...{type, providersList}}/>
                </div>
            </div>
        </>


    )

}

export default VirtualSports
